<template>
  <div class="lg:flex">
    <div class="lg:w-1/2 mx-auto flex content-center lg:p-4 lg:p-8">
      <img class="" src="@/assets/images/intro.png"/>
    </div>

    <div class="lg:w-1/2 flex flex-wrap content-center text-center lg:p-4 lg:p-8">

      <div>
         <p class="font-black text-5xl text-black mt-6 lg:mt-0">get the most out of your {{trialLength}}-day trial</p>

          <p class="mt-6 text-2xl text-dark"><span class="font-bold">What does your day look like?</span> Try living your "ideal day" for the duration of your trial. We guarantee you will improve.</p>



          <p class="mt-6 font-bold text-dark text-lg"> {{trialLength}} days of trial = {{trialLength}} days of improvement</p>

          <div class="flex justify-center">
            <vs-button icon-pack="feather" icon="icon-log-in" class="mt-6 text-center cursor-pointer hover:underline" @click="close">enter improvee.io</vs-button>
          </div>
      </div>


    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  data () {
   return {
    }
  },
  computed: {
    trialLength () {
      return this.$store.getters.trialLength
    }
  },
  methods: {
    close () {
    this.$store.dispatch('ADDITIONAL_USER_INFO', { showTrialJourneyStartedSeen: true })
      this.$emit('hidePopup')
    }
  }
}
</script>
